(function() {
  const GAP_PX = 0;         // gap between stacked elements
  const MOBILE_MAX = 768;   // apply only on mobile
  const OBSERVE_DELAY = 400; // debounce delay for DOM changes

  const TARGET_SELECTORS = [
    '.minimal-summary-container',
    '.sa_ca_container.ca_bottom',
    '#trustedsite-tm-image',
    '#chat-button',
  ];

  let adjustTimeout = null;

  function isElementVisible(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity || '1') === 0)
      return false;
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function adjustStackedTargets() {
    if (window.innerWidth > MOBILE_MAX) return; // only run on mobile

    const targets = TARGET_SELECTORS
      .map(sel => document.querySelector(sel))
      .filter(el => el && isElementVisible(el));

    if (targets.length === 0) return;

    let cumulative = 0;

    for (let i = 0; i < targets.length; i++) {
      const el = targets[i];
      const selector = TARGET_SELECTORS.find(sel => el.matches(sel));
      if (!selector) continue;

      const h = el.offsetHeight || el.getBoundingClientRect().height || 0;
      const bottomValue = cumulative;

      // Group TrustedSite + Chat Button together
      if (selector === '#trustedsite-tm-image' || selector === '#chat-button') {
        const trusted = document.querySelector('#trustedsite-tm-image');
        const chat = document.querySelector('#chat-button');
        [trusted, chat].forEach(el2 => {
          if (el2 && isElementVisible(el2)) {
            el2.style.setProperty('bottom', bottomValue + 'px', 'important');
          }
        });
        i = Math.max(i, targets.findIndex(t => t.matches('#chat-button')));
        continue;
      }

      el.style.setProperty('bottom', bottomValue + 'px', 'important');
      cumulative += h + GAP_PX;
    }
  }

  function scheduleAdjust() {
    clearTimeout(adjustTimeout);
    adjustTimeout = setTimeout(adjustStackedTargets, OBSERVE_DELAY);
  }

  // Events
  window.addEventListener('load', adjustStackedTargets);
  window.addEventListener('resize', scheduleAdjust);
  window.addEventListener('orientationchange', scheduleAdjust);

  // Observe only body children — not entire document
  const mo = new MutationObserver(scheduleAdjust);
  mo.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });

  window.__stackedBadges = {
    adjust: adjustStackedTargets,
    stop: () => {
      mo.disconnect();
      clearTimeout(adjustTimeout);
      window.removeEventListener('resize', scheduleAdjust);
      window.removeEventListener('orientationchange', scheduleAdjust);
    },
    targets: TARGET_SELECTORS
  };

  adjustStackedTargets();
})();
